/* Viewing contents works independently of stock status and theme text renderers. */
class DragonEditionsContents extends HTMLElement {
 connectedCallback(){
  this.controller?.abort();this.controller=new AbortController();
  this.details=this.closest('.product-details');this.dataset.enhanced='';
  const {signal}=this.controller;
  this.addEventListener('click',event=>{
   const tab=event.target.closest('[data-dec-edition]');
   if(tab&&this.contains(tab)){
    this.showEdition(tab.dataset.decEdition);
    const input=this.details?.querySelector('variant-picker input[data-option-value-id="'+tab.dataset.optionValueId+'"]');
    if(input&&!input.checked&&!input.disabled)input.click();
    return;
   }
   const button=event.target.closest('.dec-expand');
   if(button&&this.contains(button)){
    const panel=button.closest('.dec-panel');const expanded=panel.dataset.expanded!=='true';
    panel.dataset.expanded=String(expanded);button.setAttribute('aria-expanded',String(expanded));button.textContent=expanded?'Show less −':'View full contents +';
   }
  },{signal});
  this.details?.addEventListener('variant:update',()=>{
   const index=Number(this.dataset.editionPosition)-1;
   const selected=this.details.querySelector('variant-picker input[data-fieldset-index="'+index+'"]:checked');
   if(selected)this.showEdition(selected.value);
  },{signal});
 }
 disconnectedCallback(){this.controller?.abort();}
 showEdition(edition){
  if(![...this.querySelectorAll('[data-dec-panel]')].some(p=>p.dataset.decPanel===edition))return;
  this.querySelectorAll('[data-dec-edition]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.decEdition===edition)));
  this.querySelectorAll('[data-dec-panel]').forEach(p=>p.hidden=p.dataset.decPanel!==edition);
 }
}
if(!customElements.get('dragon-editions-contents'))customElements.define('dragon-editions-contents',DragonEditionsContents);
